var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 30.1666V15.9999H18.25V30.1666M1.25 11.7499L14 1.83325L26.75 11.7499V27.3333C26.75 28.0847 26.4515 28.8054 25.9201 29.3367C25.3888 29.8681 24.6681 30.1666 23.9167 30.1666H4.08333C3.33189 30.1666 2.61122 29.8681 2.07986 29.3367C1.54851 28.8054 1.25 28.0847 1.25 27.3333V11.7499Z",
    stroke: "#B2FC02",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGreen);
export default __webpack_public_path__ + "static/media/homeGreen.00f02df89135bd47f091a998c7696e85.svg";
export { ForwardRef as ReactComponent };